/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Alert_TextInputs */

const en_iframe_remote_alert_text = /** @type {(inputs: Iframe_Remote_Alert_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is an alert message.`)
};

const fr_iframe_remote_alert_text = /** @type {(inputs: Iframe_Remote_Alert_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceci est un message d'alerte.`)
};

const de_iframe_remote_alert_text = /** @type {(inputs: Iframe_Remote_Alert_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dies ist eine Warnmeldung.`)
};

const it_iframe_remote_alert_text = /** @type {(inputs: Iframe_Remote_Alert_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo è un messaggio di avviso.`)
};

const ru_iframe_remote_alert_text = /** @type {(inputs: Iframe_Remote_Alert_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Это предупреждающее сообщение.`)
};

const es_iframe_remote_alert_text = /** @type {(inputs: Iframe_Remote_Alert_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este es un mensaje de alerta.`)
};

const zh_cn2_iframe_remote_alert_text = /** @type {(inputs: Iframe_Remote_Alert_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这是一条警报信息。`)
};

const ja_iframe_remote_alert_text = /** @type {(inputs: Iframe_Remote_Alert_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`これは警告メッセージです。`)
};

const hi_iframe_remote_alert_text = /** @type {(inputs: Iframe_Remote_Alert_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह एक चेतावनी संदेश है।`)
};

const pt_pt2_iframe_remote_alert_text = /** @type {(inputs: Iframe_Remote_Alert_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta é uma mensagem de alerta.`)
};

/**
* | output |
* | --- |
* | "This is an alert message." |
*
* @param {Iframe_Remote_Alert_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_alert_text = /** @type {((inputs?: Iframe_Remote_Alert_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Alert_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_alert_text(inputs)
	if (locale === "de") return de_iframe_remote_alert_text(inputs)
	if (locale === "it") return it_iframe_remote_alert_text(inputs)
	if (locale === "ru") return ru_iframe_remote_alert_text(inputs)
	if (locale === "es") return es_iframe_remote_alert_text(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_alert_text(inputs)
	if (locale === "ja") return ja_iframe_remote_alert_text(inputs)
	if (locale === "hi") return hi_iframe_remote_alert_text(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_alert_text(inputs)
	return en_iframe_remote_alert_text(inputs)
});